import { SelfDescribingJson } from '@snowplow/tracker-core';
import { BrowserPlugin, cookie } from '@snowplow/browser-tracker-core';

export interface Cookies {
  fptUUID?: string;
  [key: string]: string | undefined;
}

const ANALYTICS_COOKIES_SCHEMA = 'iglu:vn.fpt.cdp.snowplow/cads/jsonschema/1-0-0';

interface CDPPluginOptions {
  fptUuid?: boolean;
}

const defaultPluginOptions: CDPPluginOptions = {
  fptUuid: true,
};

export function CDPPlugin(pluginOptions: CDPPluginOptions = defaultPluginOptions): BrowserPlugin {
  return {
    contexts: () => {
      const contexts: SelfDescribingJson<Record<string, unknown>>[] = [];
      const { fptUuid } = { ...defaultPluginOptions, ...pluginOptions };
      const USER_COOKIE = 'fpt_uuid';
      if (fptUuid) {
        const uaCookiesContext: SelfDescribingJson<Cookies> = {
          schema: ANALYTICS_COOKIES_SCHEMA,
          data: {},
        };
        [USER_COOKIE].forEach(function (cookieType) {
          var value = cookie(cookieType);
          if (value) {
            try {
              value = JSON.parse(value)
            } catch (e){ }
            uaCookiesContext.data[cookieType] = value;
          }
        });
        contexts.push(uaCookiesContext);
      }
      return contexts;
    },
  };
}
